import { formatDistanceToNowStrict, isValid } from "date-fns";
import { parseUtcTimestamp } from "../../../helpers/formatDateTime";

export const INACTIVITY_OPTIONS = Object.freeze([
    { value: "ThreeMonths", label: "3 months" },
    { value: "SixMonths", label: "6 months" },
    { value: "NineMonths", label: "9 months" },
    { value: "OverOneYear", label: "1 year or more" },
]);

export const DEFAULT_INACTIVITY_PERIOD = "SixMonths";

export const ALL_TEAM_LEADERS_OPTION = Object.freeze({
    value: "",
    label: "All Team Leaders",
});

const toArray = (value) => (Array.isArray(value) ? value : []);

const getEmployeeId = (employee) =>
    employee?.employeeId ??
    employee?.EmployeeId ??
    employee?.id ??
    employee?.Id;

const getEmployeeName = (employee) => {
    const directName =
        employee?.fullName ??
        employee?.FullName ??
        employee?.name ??
        employee?.Name;

    if (typeof directName === "string" && directName.trim()) {
        return directName.trim();
    }

    return `${employee?.firstName ?? employee?.FirstName ?? ""} ${
        employee?.lastName ?? employee?.LastName ?? ""
    }`.trim();
};

export const buildTeamLeaderOptions = (teamLeaders) => {
    const leadersByEmployeeId = new Map();

    toArray(teamLeaders).forEach((employee) => {
        const employeeId = getEmployeeId(employee);
        const label = getEmployeeName(employee);
        if (!employeeId || !label) return;

        const key = String(employeeId);
        if (!leadersByEmployeeId.has(key)) {
            leadersByEmployeeId.set(key, {
                value: employeeId,
                label,
            });
        }
    });

    return [...leadersByEmployeeId.values()].sort((left, right) =>
        left.label.localeCompare(right.label, undefined, {
            sensitivity: "base",
        }),
    );
};

export const formatInactiveDuration = (lastActivityAt) => {
    if (!lastActivityAt) return "";

    const date = parseUtcTimestamp(lastActivityAt);

    if (!isValid(date)) return "";

    return `${formatDistanceToNowStrict(date, {
        roundingMethod: "floor",
    })} inactive`;
};
